import { useState } from 'react';
import { Alert, Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { login, fetchAuthStatus } from '../api/authApi';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: authData } = useQuery({
    queryKey: ['auth-status'],
    queryFn: fetchAuthStatus,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const data = await login(username, password);
      queryClient.setQueryData(['auth-status'], data);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Failed to log in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex flex-column justify-content-center bg-body-tertiary">
      <Row className="g-0 justify-content-center">
        <Col md={8} lg={4}>
          <div className="text-center mb-4">
            <h1 className="h3 mb-3 fw-bold">Netflix2 <small className="text-muted">{authData?.version || ''}</small></h1>
          </div>
          <Card className="shadow border-0">
            <Card.Body className="p-4">
              <h3 className="mb-4 text-center">Sign in</h3>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form className="d-grid gap-3" onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    size="lg"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    size="lg"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button size="lg" type="submit" disabled={loading} className="mt-2">
                  {loading ? <Spinner animation="border" size="sm" /> : 'Log in'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
          <p className="mt-5 mb-3 text-body-secondary text-center">&copy; 2026</p>
        </Col>
      </Row>
    </div>
  );
}
